.chart {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: var(--space-2);
  padding: var(--space-5);
}

.yTitle {
  align-self: center;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap;
  font-size: var(--text-sm);
  font-weight: var(--weight-bold);
  color: var(--text-secondary);
}

.columns {
  display: flex;
  gap: 3px;
  min-width: 0;
}

/* Width is the column's share; a floor keeps a tiny region legible */
.column {
  flex: var(--w) 1 0;
  min-width: 64px;
  display: flex;
  flex-direction: column;
}

.plot {
  position: relative;
  height: 280px;
  border-bottom: 1px solid var(--border-default);
}

.bar {
  position: absolute;
  inset: auto 0 0;
  height: var(--h);
  min-height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: var(--space-2);
  border-radius: var(--radius-sm) var(--radius-sm) 0 0;
  background: color-mix(in srgb, var(--color) 78%, transparent);
  transition: background var(--duration-fast);
}

.column:hover .bar {
  background: var(--color);
}

.column[data-highlight] .bar {
  box-shadow: inset 0 0 0 2px var(--accent-secondary);
}

/* ARPU sits on top of the bar */
.height {
  position: absolute;
  bottom: calc(100% + var(--space-1));
  left: 0;
  right: 0;
  text-align: center;
  font-family: var(--font-display);
  font-size: 18px;
  letter-spacing: 0.02em;
  color: var(--text-primary);
}

/* Revenue share inside, from the bar's foot */
.area {
  display: flex;
  flex-direction: column;
  font-family: var(--font-display);
  font-size: 22px;
  line-height: 1;
  color: var(--color-white);
  text-shadow: 0 1px 2px color-mix(in srgb, var(--color-black) 40%, transparent);
}

.areaLabel {
  margin-top: 2px;
  font-family: var(--font-sans);
  font-size: var(--text-xs);
  opacity: 0.9;
}

.foot {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: var(--space-2);
  min-width: 0;
}

.name {
  font-size: var(--text-sm);
  font-weight: var(--weight-semi);
  color: var(--text-primary);
}

.width {
  font-size: var(--text-xs);
  color: var(--text-muted);
  white-space: nowrap;
}
